import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const ErrorPage = ({ route: { status } }) => (
  <div className="flex flex-column flex-align-center text-align-center">
    <span className="icon icon-xl dls-icon-warning dls-color-warning margin-4-b" />
    <div>
      <h4 className="dls-gray-05 heading-4 margin-4-b">
        {
            status === 404
              ? <FormattedMessage id="page.not.found.title" />
              : <FormattedMessage id="loading.error.title" />
          }
      </h4>
      <p className="dls-body-3">
        {
            status === 404
              ? <FormattedMessage id="page.not.found.description" />
              : <FormattedMessage id="loading.error.description" />
          }
      </p>
    </div>
  </div>
);

ErrorPage.propTypes = {
  route: PropTypes.shape({
    status: PropTypes.number,
  }).isRequired,
};

export default ErrorPage;
